<template>
  <!-- 山东颐养健康集团莱芜中心医院 -->
  <div class="pageContent">
    <!-- <img src="../../../assets/wuxue.png" alt="Login logo" class="loginLogo" /> -->
    <div class="hosName">山东颐养健康集团莱芜中心医院</div>
    <!-- 病历号，身份证号，住院号 -->
    <div class="ourterTitle">姓名/身份证号/检查号/住院号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value25500005.name25500005"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value25500005.value1"
          placeholder="请输入身份证号/检查号/住院号查询"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      rules: true,
      value25500005: {
        name25500005: "",
        value1: "",
      },
    };
  },
  methods: {
    inputFn() {
      if (this.value25500005.name25500005 != "" && this.value25500005.value1 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value25500005", JSON.stringify(this.value25500005));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name25500005")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  .hosName {
    font-size: 20px;
    // padding: 10px 0;
    padding: 65px 0 10px;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 15px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
